// Single source of truth for the agenda views a tenant can pick as default.
// The settings dropdown (DefaultAgendaView.jsx) renders these options; the
// resolver below validates the stored value against the same list, so the
// picker and the validator can never drift apart.
export const AGENDA_VIEW_OPTIONS = [
    { value: 'listWeek', label: 'Lijst' },
    { value: 'timeGridDay', label: 'Dag' },
    { value: 'timeGridWeek', label: 'Week' },
    { value: 'dayGridMonth', label: 'Maand' },
];

// Maps the tenant-level DefaultAgendaView setting (CompagnyMeta) to a valid
// FullCalendar view name. Unknown or missing values fall back to week view,
// which was the hardcoded default before this setting existed.
const VALID_VIEWS = AGENDA_VIEW_OPTIONS.map((option) => option.value);

const resolveAgendaView = (setting) => {
    return VALID_VIEWS.includes(setting) ? setting : 'timeGridWeek';
};

export default resolveAgendaView;
